export const SidebarDataCrc = [
  {
    title: 'Dashboard',
    path: '/',
    cName: 'nav-text'
  },
  {
    title: 'Alumni Directory',
    path: '/alumni_directory',
    cName: 'nav-text'
  },
  {
    title: 'Events',
    path: '/events',
    cName: 'nav-text'
  },
  {
    title: 'Career Opportunity',
    path: '/career_opportunity_staff',
    cName: 'nav-text'
  },
  {
    title: 'Further Education',
    path: '/further_education_staff',
    cName: 'nav-text'
  },

    {
    title: 'Add Data',
    path: '/add_data', // This route can be updated later
    cName: 'nav-text'
  }
];

